import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AleadyLoggedInGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {

    if (this.authService.isAuthenticated()) {
      const accountType = this.authService.getRole();

      if (['ADMIN', 'SUPER_ADMIN', 'CHAIRMAN_LGA'].includes(accountType)) {
        this.router.navigate(['/admin/dashboard']);
        return false;
      } else if (['LGA_ADMIN', 'LGA_APPROVING_ADMIN',].includes(accountType)) {
        this.router.navigate(['/admin/igr-assessment']);
        return false;
      }
      else if (['USER', 'SUB_AGENT', 'SUPER_AGENT'].includes(accountType)) {
        this.router.navigate(['/user/transaction-history']);
        return false;
      }


    }

    return true;
  }
}
